import React,{useState} from 'react'
import GameRoutes from '../../route/gameroutes/GameRoutes'
import SearchBar from '../../route/searchbar/SearchBar'
import Token from '../../component/token/Token'
import './DotaPage.scss'
import ceklis from '../../assets/ceklis.png'
import dota from '../../assets/dota.png'
import Terms from '../../component/termsmodal/Terms'
import Activation from '../../component/activation/Activation'

const DotaPage = () => {

    const [show,setShow] = useState(false)
    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)
    const [show4,setShow4] = useState(false)

    const [showAct,setShowAct] = useState(false)


    const close = () => {
        setShow(false)
        setShow2(false)
        setShow3(false)
        setShow4(false)
        setShowAct(false)
    }
    return (
        <>
            <div className="dota__white">
                <div className="dota__container">
                    <SearchBar/>
                    <GameRoutes/>
                    <div className="dota__header">
                        <div className="dota__text">
                            <p>DOTA 2</p>
                        </div>
                        <div className="dota__activated" onClick={() => setShowAct(true)}>
                            <img src={ceklis} alt="ceklis"/>
                            <p>Activated</p>
                        </div>
                    </div>
                    <Token onClick={() => setShow(true)} onClick2={() => setShow2(true)} onClick3={() => setShow3(true)} onClick4={() => setShow4(true)}/>
                        {show && <Terms bgCover="dota--modal" header="SOLO LEAGUE" onClose={close} imagelogo={dota}/>}
                        {show2 && <Terms bgCover="dota--modal" header="SOLO Challange" onClose={close} imagelogo={dota}/>}
                        {show3 && <Terms bgCover="dota--modal" header="TEAM Round of 8" onClose={close} imagelogo={dota}/>}
                        {show4 && <Terms bgCover="dota--modal" header="TEAM LEAGUE" onClose={close} imagelogo={dota}/>}
                        {showAct && <Activation bgCover="dota--bg" onClose={close} imageLogo={dota}/>}
                </div>
            </div>
        </>
    )
}

export default DotaPage
